var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentnull"},[_c('div',{staticClass:"m-results-m1"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"pic"},[_c('img',{attrs:{"src":require("../assets/images/home/results_null.png")}})]),_c('div',{staticClass:"txt"},[_c('p',[_vm._v("未检索到相关资料内容")]),_c('p',[_vm._v("请试试其他关键词")])])])])])
}]

export { render, staticRenderFns }